<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="primary"
            :disabled="!claimEntitlement.claim_type.has_limit"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-plus-minus-box
            </v-icon>
          </v-btn>
        </template>
        <span>Add / Deduct Amount</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Entitlement"
      text="Claim Entitlement Adjustment"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="localClaimEntitlement.claim_type.name"
                label="Claim Entitlement"
                readonly
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="assignable"
                class="py-0"
                :label="localClaimEntitlement.assignable.person ? 'Employee' : 'Department'"
                readonly
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="adjustedAmount"
                v-validate="'required|validInput'"
                :error-messages="errors.collect('adjustedAmount')"
                label="Add / Deduct Amount"
                data-vv-name="adjustedAmount"
                data-vv-as="amount"
                prefix="RM"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-textarea
                v-model="remark"
                v-validate="'required|max:500'"
                :error-messages="errors.collect('remark')"
                :rows="3"
                data-vv-name="remark"                
                label="Remark"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="px-10 white--text"         
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimEntitlement: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        form: null,
        progressing: false,
        localClaimEntitlement: null,
        adjustedAmount: 0,
        assignable: '',
        remark: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.localClaimEntitlement = { ...this.claimEntitlement }
        this.assignable = this.localClaimEntitlement.assignable.person ? this.localClaimEntitlement.assignable.person.name : this.localClaimEntitlement.assignable.name
      
        this.$validator.extend('validInput', {
          getMessage (field, args) {
            return 'Invalid input'
          },
          validate (value, args) {
            if (!value) return false

            const num = parseFloat(value)
            if (isNaN(num) || num === 0) return false

            // Check decimal places
            const match = String(value).match(/^(-?\d+)(\.\d{1,2})?$/)
            return !!match
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.claimEntitlementAdjustments().create(this.claimEntitlement.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                  this.adjustedAmount = 0
                  this.remark = null
                }
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                } else {
                  this.$snack({ 
                    message: 'Unable to adjust claim entitlement',
                    color: 'error',
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          adjusted_amount: this.adjustedAmount.toString().replaceAll(',', ''),
          remark: this.remark,
        }
      },
    },
  }
</script>
